module.exports = __webpack_public_path__ + "img/wonder_wall.c208b46c.svg";